"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = exports.States = exports.definitionCatalogueItems = exports.Definition = exports.Definitions = exports.LiquidEnhancement = exports.CO2Tank = exports.UVCLight = exports.MicroPurityFilter = exports.CulliganGlobalFilter = exports.LimescaleFilter = exports.CarbonBlockFilter = exports.PreCarbonBlockFilter = exports.Enhancement = exports.hasBatch = exports.isExpirable = exports.ExpendableInHours = exports.ExpendableInLiters = exports.DepletableInKilograms = exports.DepletableInLiters = exports.DepletableInGrams = exports.Expendable = exports.Depletable = exports.Name = exports.Id = void 0;
/* eslint-disable import-x/order */
const effect_1 = require("effect");
const pre_carbon_block_filter_1 = require("./pre-carbon-block-filter");
const carbon_block_filter_1 = require("./carbon-block-filter");
const limescale_filter_1 = require("./limescale-filter");
const culligan_global_filter_1 = require("./culligan-global-filter");
const micro_purity_filter_1 = require("./micro-purity-filter");
const uvc_light_1 = require("./uvc-light");
const co2_tank_1 = require("./co2-tank");
const liquid_enhancement_1 = require("./liquid-enhancement");
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition';
var common_1 = require("./common");
Object.defineProperty(exports, "Id", { enumerable: true, get: function () { return common_1.Id; } });
Object.defineProperty(exports, "Name", { enumerable: true, get: function () { return common_1.Name; } });
Object.defineProperty(exports, "Depletable", { enumerable: true, get: function () { return common_1.Depletable; } });
Object.defineProperty(exports, "Expendable", { enumerable: true, get: function () { return common_1.Expendable; } });
Object.defineProperty(exports, "DepletableInGrams", { enumerable: true, get: function () { return common_1.DepletableInGrams; } });
Object.defineProperty(exports, "DepletableInLiters", { enumerable: true, get: function () { return common_1.DepletableInLiters; } });
Object.defineProperty(exports, "DepletableInKilograms", { enumerable: true, get: function () { return common_1.DepletableInKilograms; } });
Object.defineProperty(exports, "ExpendableInLiters", { enumerable: true, get: function () { return common_1.ExpendableInLiters; } });
Object.defineProperty(exports, "ExpendableInHours", { enumerable: true, get: function () { return common_1.ExpendableInHours; } });
Object.defineProperty(exports, "isExpirable", { enumerable: true, get: function () { return common_1.isExpirable; } });
Object.defineProperty(exports, "hasBatch", { enumerable: true, get: function () { return common_1.hasBatch; } });
exports.Enhancement = __importStar(require("./enhancement"));
exports.PreCarbonBlockFilter = __importStar(require("./pre-carbon-block-filter"));
exports.CarbonBlockFilter = __importStar(require("./carbon-block-filter"));
exports.LimescaleFilter = __importStar(require("./limescale-filter"));
exports.CulliganGlobalFilter = __importStar(require("./culligan-global-filter"));
exports.MicroPurityFilter = __importStar(require("./micro-purity-filter"));
exports.UVCLight = __importStar(require("./uvc-light"));
exports.CO2Tank = __importStar(require("./co2-tank"));
exports.LiquidEnhancement = __importStar(require("./liquid-enhancement"));
exports.Definitions = {
    PreCarbonBlockFilter: pre_carbon_block_filter_1.PreCarbonBlockFilter,
    CarbonBlockFilter: carbon_block_filter_1.CarbonBlockFilter,
    LimescaleFilter: limescale_filter_1.LimescaleFilter,
    CulliganGlobalFilter: culligan_global_filter_1.CulliganGlobalFilter,
    MicroPurityFilter: micro_purity_filter_1.MicroPurityFilter,
    UVCLight: uvc_light_1.UVCLight,
    CO2Tank: co2_tank_1.CO2Tank,
    LiquidEnhancement: liquid_enhancement_1.LiquidEnhancement,
};
exports.Definition = effect_1.Schema.Union(...effect_1.Record.values(exports.Definitions)).annotations({
    identifier: `${NAMESPACE}.Definition`,
});
exports.definitionCatalogueItems = (0, effect_1.pipe)(exports.Definitions, effect_1.Record.map(({ catalogue }) => effect_1.Record.values(catalogue)), effect_1.Record.values, effect_1.Array.flatten);
exports.States = {
    PreCarbonBlockFilter: pre_carbon_block_filter_1.PreCarbonBlockFilter.State,
    CarbonBlockFilter: carbon_block_filter_1.CarbonBlockFilter.State,
    LimescaleFilter: limescale_filter_1.LimescaleFilter.State,
    CulliganGlobalFilter: culligan_global_filter_1.CulliganGlobalFilter.State,
    MicroPurityFilter: micro_purity_filter_1.MicroPurityFilter.State,
    UVCLight: uvc_light_1.UVCLight.State,
    CO2Tank: co2_tank_1.CO2Tank.State,
    LiquidEnhancement: liquid_enhancement_1.LiquidEnhancement.State,
};
exports.State = effect_1.Schema.Union(...effect_1.Record.values(exports.States)).annotations({
    identifier: `${NAMESPACE}.State`,
    title: 'Consumable Definition State',
});
//# sourceMappingURL=index.js.map